"use strict";

import http from "./http-common";
import authHeader from "./auth-header";

const getOrdersForMap = (date, companyId) => {
  return http.axiosClient.get(
    `/orders/delivered?companyId=${companyId}`,
    {
      headers: authHeader(),
    }
  );
};

const getDistanceBetweenOrders = (order1Id, order2Id, type = "air") => {
  return http.axiosClient.get(
    `/map/distance?order1Id=${order1Id}&order2Id=${order2Id}&type=${type}`,
    {
      headers: authHeader(),
    }
  );
};

const getOrderDetails = (id, userLat = null, userLon = null) => {
  let url = `/map/order/${id}`;
  if (userLat && userLon) {
    url += `?userLat=${userLat}&userLon=${userLon}`;
  }
  return http.axiosClient.get(url, {
    headers: authHeader(),
  });
};

const geocodeOrder = (id) => {
  return http.axiosClient.post(
    `/map/geocode/${id}`,
    {},
    {
      headers: authHeader(),
    }
  );
};

const mapService = {
  getOrdersForMap,
  getDistanceBetweenOrders,
  getOrderDetails,
  geocodeOrder,
};

export default mapService;
